//@flow
/* eslint-disable prefer-template, no-path-concat, import/unambiguous, import/no-commonjs */
/* eslint-disable camelcase */

import { addSourceTypes } from './source-plugin';
import { modifyShaders } from './shader-plugin';
import { modifyDraws } from './draw-plugin';
import { modifyMapAndStyle } from './map-plugin';


export const gagoInit = function ({
    setSource,
    setDraw,
    setShader,
    Map,
    Style,
}) {
    addSourceTypes(setSource);
    modifyShaders(setShader);
    modifyDraws(setDraw);
    modifyMapAndStyle(Map, Style);
    // modifyStyleLayers(createLercLayer, setStyleLayer);
};
